export default "__VITE_ASSET__BoMXg4Dm__"